import axios from "axios";
import BaseApi from "./baseApi";

export default class MachineLicense extends BaseApi {
  getLicense(machId) {
    return axios
      .get(`${this.url}/api/${this.organizationCode}/machines/${machId}/license`)
      .then(response => response.data.result);
  }
}
